import { gql, useMutation } from '@apollo/client';
import {
  InitiateKlarnaPaymentMutation,
  InitiateKlarnaPaymentMutationVariables,
} from '@/types';

export const INITIATE_KLARNA_PAYMENT_MUTATION = gql`
  mutation InitiateKlarnaPayment(
    $restaurantId: uuid!
    $supplierId: uuid!
    $invoices: [InvoiceInput!]!
    $creditMemos: [CreditMemoInput!]!
    $paymentMethod: String!
    $feesInMicros: bigint
    $returnUrl: String
  ) {
    initiateKlarnaPayment(
      restaurant_id: $restaurantId
      supplier_id: $supplierId
      invoices: $invoices
      credit_memos: $creditMemos
      payment_method: $paymentMethod
      fees_in_micros: $feesInMicros
      return_url: $returnUrl
    ) {
      alert_level
      alert_message
      klarna_action
      payment_batch_id
    }
  }
`;

export const useInitiateKlarnaPayment = () =>
  useMutation<
    InitiateKlarnaPaymentMutation,
    InitiateKlarnaPaymentMutationVariables
  >(INITIATE_KLARNA_PAYMENT_MUTATION);
